module.exports = __webpack_public_path__ + "img/Angeberinnen.f267d7b4.jpg";